import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function SCHowItWorks() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-1860">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1861">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1862">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-1863">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-1864">
              <img src="https://cdn.magicpatterns.com/uploads/qcFPkXmcGLwzrQJmmGWn56/sculptra-injection.jpg" alt="Sculptra Injection Treatment" className="w-full h-full object-cover" data-id="element-1865" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1866">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-1867">
              HOW DOES SCULPTRA WORK?
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1868"></div>

            <div className="space-y-6 text-[#B0B0B0] text-base leading-[1.8] font-body" data-id="element-1869">
              <p data-id="element-1870">
                Once injected, Sculptra acts as a bioactivator, prompting the
                skin's innate healing mechanisms. The PLLA particles in Sculptra
                encourage the generation of fresh collagen, which restores
                volume, refines skin texture, and diminishes wrinkles and folds.
              </p>
              <p data-id="element-1871">
                The treatment journey typically spans multiple sessions across
                several months, allowing for the gradual emergence of collagen
                and the attainment of natural-looking enhancements. The number
                of sessions needed can vary depending on individual requirements
                and treatment areas.
              </p>
              <p data-id="element-1872">
                As the newly generated collagen integrates with the skin's
                existing fibers, the effects of Sculptra become evident. Treated
                areas gradually become smoother, firmer, and more youthful.
                While results can endure for up to two years, their duration may
                differ based on individual factors and lifestyle choices.
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}